/* eslint-disable */
import anime from 'animejs';

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {



      function animateGauge(gauge) {
        var gaugeElement = $(gauge);
        var path = $(gaugeElement).find('.path').get(0);
        var length = path.getTotalLength();
        var percentage = gaugeElement.attr("data-percent");
        var percentageLenght = (percentage * length) / 100;
        var animatedNumber = gaugeElement.find('.animated-number').get(0);
        //console.log(length + " " + percentage + " " + percentageLenght);

        const endValue = percentage;
        const incrementValue = 1;
        const durationValue = 2000;

        anime({
          targets: path,
          strokeDashoffset: [anime.setDashoffset, length - percentageLenght],
          easing: 'easeInOutSine',
          delay: 500,
          duration: 2000,

          begin: function(anim) {
              
              gaugeElement.find('.animated-circle').css('opacity', '1');
              numberAnimation(animatedNumber, endValue, incrementValue, durationValue);

            }
        });

      }

      

    function numberAnimation(el, endValue, incrementor, duration) {
      anime({
        targets: el,
        textContent: endValue,
        round: incrementor ? 1/incrementor : 1/5,
        easing: 'easeInOutSine',
        delay: 500,
        duration: duration ? duration : 2000,

        update: function(a) {
          const value = a.animations[0].currentValue;
          
          el.innerHTML = (value+"<span>%</span>").split(' ').join('');

        }

      });
    }


    const config = {
      root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
      rootMargin: '-20% 0% -20% 0%',
      threshold: 0
    };

    //check to see if there is more than one cover-component on this page
    var allGauges = $('#main').find('.gauge-item'); 

    let observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {

            if (entry.isIntersecting) {
              // we are ENTERING the "capturing frame". Set the flag.
              console.log('in view');
              animateGauge(entry.target);
              observer.unobserve(entry.target);

            }

          });
          
    }, config);

    allGauges.each(function() {
        observer.observe($( this )[ 0 ]);

    });



  },
};



// WEBPACK FOOTER //
// ./scripts/components/gauges.js